module.exports = __webpack_public_path__ + "img/ForumOfficer.454dd946.svg";